import '../partials/bootstrap'
import '../vendor/cookies';
import './components/collapsible_controller'

// import "bootstrap/dist/css/bootstrap.min.css"
import { Carousel } from "bootstrap"

window.bootstrap = { Carousel: Carousel }
